module.exports = __webpack_public_path__ + "static/img/chef-logo.8b66c66.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/chef-logo.png
// module id = 528
// module chunks = 3